import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col min-h-full p-2 bg-white shadow-md rounded-3xl shadow-black/5 ring-1 ring-black/5" }
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { class: "flex flex-col flex-1 p-8" }
const _hoisted_5 = { class: "text-gray-700 text-sm/5 blog-tag-list" }
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = { class: "mt-2 font-medium text-base/7" }
const _hoisted_8 = ["href", "alt", "title"]
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "flex-1 mt-2 text-gray-600 text-sm/6" }
const _hoisted_11 = { class: "z-10 flex items-center gap-3 mt-6" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "text-gray-700 text-sm/5" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "z-10 shrink-0 mt-2 ml-4" }
const _hoisted_18 = { class: "relative inline-flex items-center" }


import {BlogPostDtoLightweight} from "@/dtos";
import Bookmarking from "@/main/components/Bookmarking.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogPostCard',
  props: {
    post: {}
  },
  setup(__props: any) {

const props = __props;

const post: BlogPostDtoLightweight = props.post;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(post).featuredImageUrl)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: `/blog/${_unref(post).slug}`,
          alt: _unref(post).title,
          title: _unref(post).title
        }, [
          _createElementVNode("img", {
            src: _unref(post).featuredImageUrl,
            alt: _unref(post).title,
            title: _unref(post).title,
            class: "aspect-[3/2] w-full rounded-2xl object-cover"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post).categories, (category) => {
          return (_openBlock(), _createElementBlock("span", {
            key: category,
            class: "z-10 py-1 mr-1 text-xs font-medium rounded-full text-sa-raspberry-900"
          }, [
            _createElementVNode("a", {
              href: `/blog/?categories=${category}`,
              title: category
            }, _toDisplayString(category), 9, _hoisted_6)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          href: `/blog/${_unref(post).slug}`,
          alt: _unref(post).title,
          title: _unref(post).title
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute inset-0" }, null, -1)),
          _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(post).title), 1)
        ], 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(post).excerpt), 1),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post).authors, (author) => {
          return (_openBlock(), _createElementBlock("a", {
            key: author.slug,
            href: `/author/${author.slug}`
          }, [
            _createElementVNode("img", {
              class: "object-cover rounded-full aspect-square size-6",
              src: author.headshotUrl,
              alt: author.name
            }, null, 8, _hoisted_13)
          ], 8, _hoisted_12))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _cache[1] || (_cache[1] = _createTextVNode("By ")),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post).authors, (author) => {
            return (_openBlock(), _createElementBlock("a", {
              key: author.slug,
              href: `/author/${author.slug}`,
              class: "hover:underline"
            }, _toDisplayString(author.name), 9, _hoisted_15))
          }), 128)),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(post).publishedOnAsString), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Bookmarking, {
              id: _unref(post).id
            }, null, 8, ["id"])
          ])
        ])
      ])
    ])
  ]))
}
}

})